import { DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

/** En-tête des modales de l'accueil : pastille d'icône, titre, sous-titre. */
export const HomeDialogHeader = ({
  icon,
  title,
  description,
  iconBoxClassName = "bg-brand-50 text-primary",
}: {
  icon: ReactNode;
  title: string;
  description: string;
  iconBoxClassName?: string;
}) => (
  <header className="flex items-center gap-3 border-b border-slate-200 pb-4">
    <span
      className={cn(
        "flex size-10 shrink-0 items-center justify-center rounded-md",
        iconBoxClassName,
      )}
    >
      {icon}
    </span>
    <div className="min-w-0">
      <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
      <DialogDescription className="text-sm text-slate-500">
        {description}
      </DialogDescription>
    </div>
  </header>
);
